import {IconColumn, IconColumnConfig} from './icon-column.model';

export class ActionColumn extends IconColumn {
  action: Function;

  constructor(title: string,
              config: ActionColumnConfig) {
    super(title,
      {
        property: config.property,
        icons: config.icons,
      });
    this._columnType = 'ActionColumn';
    this.action = config.action;
  }

  get(element: any): any {
    return super.get(element);
  }
}

interface ActionColumnConfig extends IconColumnConfig {
  action: Function;
}
